window.initCareerCTA = function(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    },
    { threshold: 0.1 }
  );

  section.querySelectorAll('.career-cta-reveal').forEach((el) => observer.observe(el));
};

// Auto-initialize all career-cta sections on page load
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('[id^="shopify-section-"]');
    sections.forEach(function(section) {
      if (section.querySelector('.career-cta-section')) {
        window.initCareerCTA(section.id);
      }
    });
  });
})();
